import axios from 'axios';

export class CatalogUserService {
    /**
     * Función que hace una llamada al back para consultar el catálogo de
     * cuentas de acuerdo a la institución.
     * @returns {Promise<any>} Respuesta de la petición que regresa la lista
     * de cuentas o algún mensaje de error.
     */
    getCatalogInstitutionAccounts() {
        return axios.get('/appapv/getCatalogInstitutionAccounts.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getCatalogInstitutionAccountsById(institutionId) {
        return axios.get('/appapv/getCatalogInstitutionAccountsById.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucion: institutionId
            }
        }).then(res => res.data.payload);
    }
}